app.factory('patientModel', ['$rootScope', '$q', 'baseModel', 'patientService',
    function($rootScope, $q, baseModel, patientService) {

	    function PatientModel() {

			this.getById = function(id) {
				return patientService.getById(id).then(
					function (patient) {
						$rootScope.$broadcast(Event.PATIENT.GET_BY_ID.SUCCESS, patient);
						return patient;
					},
					function(error) {
						$rootScope.$broadcast(Event.PATIENT.GET_BY_ID.ERROR, error);
						$q.reject(error);
					}
				)
			};

			this.getDataPage = function(criteria) {
				return patientService.getDataPage(criteria).then(
					function (dataPage) {
						$rootScope.$broadcast(Event.PATIENT.GET_DATA_PAGE.SUCCESS, dataPage, criteria.pageNumber);
						return dataPage;
					},
					function(error) {
						$rootScope.$broadcast(Event.PATIENT.GET_DATA_PAGE.ERROR, error);
						$q.reject(error);
					}
				)
			};

			this.getStateOfHealth = function(id) {
				return patientService.getStateOfHealth(id).then(
					function (stateOfHealthWrapper) {
						$rootScope.$broadcast(Event.PATIENT.GET_STATE_OF_HEALTH.SUCCESS, stateOfHealthWrapper);
						return stateOfHealthWrapper;
					},
					function(error) {
						$rootScope.$broadcast(Event.PATIENT.GET_STATE_OF_HEALTH.ERROR, error);
						$q.reject(error);
					}
				)
			};

			this.getStateOfHealthSummaryWithDeleted = function(id) {
				return patientService.getStateOfHealthSummaryWithDeleted(id).then(
					function (stateOfHealthWrapper) {
						return stateOfHealthWrapper;
					},
					function(error) {
						$q.reject(error);
					}
				)
			};

			this.save = function(patient) {
				return patientService.save(patient).then(
					function (patient) {
						$rootScope.$broadcast(Event.PATIENT.SAVE.SUCCESS, patient);
						baseModel.broadcastOperationSucceeded();
						return patient;
					},
					function(error) {
						$rootScope.$broadcast(Event.PATIENT.SAVE.ERROR, error);
						$q.reject(error);
					}
				)
			};

			this.update = function(patient) {
				return patientService.update(patient).then(
					function (patient) {
						$rootScope.$broadcast(Event.PATIENT.UPDATE.SUCCESS, patient);
						baseModel.broadcastOperationSucceeded();
						return patient;
					},
					function(error) {
						$rootScope.$broadcast(Event.PATIENT.UPDATE.ERROR, error);
						$q.reject(error);
					}
				)
			};

			this.delete = function(patient) {
				return patientService.delete(patient).then(
					function (patient) {
						$rootScope.$broadcast(Event.PATIENT.DELETE.SUCCESS, patient);
						baseModel.broadcastOperationSucceeded();
						return patient;
					},
					function(error) {
						$rootScope.$broadcast(Event.PATIENT.DELETE.ERROR, error);
						$q.reject(error);
					}
				)
			};

			this.saveAuthorizedPerson = function(patient, authorizedPerson) {
				return patientService.saveAuthorizedPerson(patient, authorizedPerson).then(
					function (data) {
						$rootScope.$broadcast(Event.PATIENT.SAVE_AUTHORIZED_PERSON.SUCCESS, data);
						baseModel.broadcastOperationSucceeded();
						return data;
					},
					function(error) {
						$rootScope.$broadcast(Event.PATIENT.SAVE_AUTHORIZED_PERSON.ERROR, error);
						$q.reject(error);
					}
				)
			};

			this.updateAuthorizedPerson = function(patient, authorizedPerson) {
				return patientService.updateAuthorizedPerson(patient, authorizedPerson).then(
					function (data) {
						$rootScope.$broadcast(Event.PATIENT.UPDATE_AUTHORIZED_PERSON.SUCCESS, data);
						baseModel.broadcastOperationSucceeded();
						return data;
					},
					function(error) {
						$rootScope.$broadcast(Event.PATIENT.UPDATE_AUTHORIZED_PERSON.ERROR, error);
						$q.reject(error);
					}
				)
			};

			this.deleteAuthorizedPerson = function(patient, authorizedPerson) {
				return patientService.deleteAuthorizedPerson(patient, authorizedPerson).then(
					function (data) {
						$rootScope.$broadcast(Event.PATIENT.DELETE_AUTHORIZED_PERSON.SUCCESS, data);
						baseModel.broadcastOperationSucceeded();
						return data;
					},
					function(error) {
						$rootScope.$broadcast(Event.PATIENT.DELETE_AUTHORIZED_PERSON.ERROR, error);
						$q.reject(error);
					}
				)
			};

			this.saveAttachment = function(patient, attachment) {
				return patientService.saveAttachment(patient, attachment).then(
					function (data) {
						$rootScope.$broadcast(Event.PATIENT.SAVE_ATTACHMENT.SUCCESS, data);
						baseModel.broadcastOperationSucceeded();
						return data;
					},
					function(error) {
						$rootScope.$broadcast(Event.PATIENT.SAVE_ATTACHMENT.ERROR, error);
						$q.reject(error);
					}
				)
			};

			this.updateAttachment = function(patient, attachment) {
				return patientService.updateAttachment(patient, attachment).then(
					function (data) {
						$rootScope.$broadcast(Event.PATIENT.UPDATE_ATTACHMENT.SUCCESS, data);
						baseModel.broadcastOperationSucceeded();
						return data;
					},
					function(error) {
						$rootScope.$broadcast(Event.PATIENT.UPDATE_ATTACHMENT.ERROR, error);
						$q.reject(error);
					}
				)
			};

			this.deleteAttachment = function(patient, attachment) {
				return patientService.deleteAttachment(patient, attachment).then(
					function (data) {
						$rootScope.$broadcast(Event.PATIENT.DELETE_ATTACHMENT.SUCCESS, data);
						baseModel.broadcastOperationSucceeded();
						return data;
					},
					function(error) {
						$rootScope.$broadcast(Event.PATIENT.DELETE_ATTACHMENT.ERROR, error);
						$q.reject(error);
					}
				)
			};
	
	    }
	
	    return new PatientModel();
	}
]);
